<template>
  <footer class="site-footer invert-color center-content-mobile" :class="topOuterDivider && 'has-top-divider'">
    <cookie-law theme="dark-lime"></cookie-law>
    <div class="container">
      <div class="site-footer-inner" :class="topDivider && 'has-top-divider'">
        <div class="footer-top space-between text-xxs">
          <c-logo />
          <c-footer-social />
        </div>
        <div class="footer-bottom space-between text-xxs invert-order-desktop">
          <c-footer-nav />
          <div class="footer-copyright">&copy; 2021-2026 StruVital B.V., {{ $t('all-rights-reserved') }} / {{ this.git_hash }} <a href="./../Struvital-Metaalunievoorwaarden-2024-4-talig.pdf" target="_blank">{{ $t('general-conditions') }}</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import CLogo from '@/components/layout/partials/Logo.vue'
import CFooterNav from '@/components/layout/partials/FooterNav.vue'
import CFooterSocial from '@/components/layout/partials/FooterSocial.vue'
import CookieLaw from 'vue-cookie-law'

export default {
  name: 'CFooter',
  components: {
    CLogo,
    CFooterNav,
    CFooterSocial,
    CookieLaw
  },
  props: {
    topOuterDivider: {
      type: Boolean,
      default: false
    },      
    topDivider: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
return {
    git_hash: process.env.VUE_APP_GIT_HASH
  };
}
}
</script>